module.exports = __webpack_public_path__ + "static/media/immutable_bad.be8431a9.png";